// extracted by mini-css-extract-plugin
export default {"root":"root___IZDVs","linkBoxContainer":"linkBoxContainer___n8lwh","title":"title___vkzHo","listItem":"listItem___HkqkW","link":"link___q0jtH"};